export default {
  props: {
    setClass: String
  }
};